import React from 'react'
import { Header, Message } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { pgaErrors, pgaHeaders } from '../../text'
import { pgaTypes } from '../pga/constantsPGA'
import PGAComponent from '../../HOC/PGAComponent'
import store, { injectAsyncReducer } from '../../store'
// import LaceyActReducer from '../../reducer/LaceyActReducer'
// import TSCAReducer from '../../reducer/TSCAReducer'
import FDAReducer from '../../reducer/FDAReducer'
import NHTSAReducer from '../../reducer/NHTSAReducer'
import PGAReducer from '../../reducer/PGAReducer'
import PgaSectionLabels from './PgaSectionLabels'

const LaceyActForm = PGAComponent(
  () => import('./laceyAct'),
  (merchandiseId, allprops) => injectAsyncReducer(store, `LaceyAct_${merchandiseId}`, PGAReducer("LACEY",/*guidxx*/allprops.pgaGuid))
)

const TSCAForm = PGAComponent(
  () => import('./tscaCert'),
  (merchandiseId, allprops) => injectAsyncReducer(store, `TSCA_${merchandiseId}`, PGAReducer("TSCA",/*guidxx*/allprops.pgaGuid))
)

const FDAForm = PGAComponent(
  () => import('./FDA'),
  (merchandiseId, allprops) => injectAsyncReducer(store, `FDA_${merchandiseId}`, FDAReducer("FDA", /*guidxx*/allprops.pgaGuid))
);

const NHTREIForm = PGAComponent(
  () => import('./NHTSA'),
  (merchandiseId, allprops) => injectAsyncReducer(store, `NHTSA_${merchandiseId}`, PGAReducer(pgaTypes.NHT_REI, /*guidxx*/allprops.pgaGuid))
);
const NHTTPEForm = PGAComponent(
  () => import('./NHTSA'),
  (merchandiseId, allprops) => injectAsyncReducer(store, `NHTSA_${merchandiseId}`, PGAReducer(pgaTypes[allprops.formType], /*guidxx*/allprops.pgaGuid))
);
// const NHTSAForm = PGAComponent(
//   () => import('./NHTSA'),
//   (merchandiseId) => injectAsyncReducer(store, `NHTSA_${merchandiseId}`, NHTSAReducer(merchandiseId))
// );

const FDAFOOForm = PGAComponent(
  () => import('./FDA_FOO'),
  (merchandiseId, allprops) => injectAsyncReducer(store, `FDA_FOO_${merchandiseId}`, PGAReducer(pgaTypes.FDA_FOO, /*guidxx*/allprops.pgaGuid))//FDA_FOO_Values
);

const FDADEVForm = PGAComponent(
  () => import('./FDA_DEV'),
  (merchandiseId, allprops) => injectAsyncReducer(store, `FDA_DEV_${merchandiseId}`, PGAReducer(pgaTypes.FDA_DEV, /*guidxx*/allprops.pgaGuid))//FDA_DEV_Values
);

const FDARADForm = PGAComponent(
  () => import('./FDA_RAD'),
  (merchandiseId, allprops) => injectAsyncReducer(store, `FDA_RAD_${merchandiseId}`, PGAReducer(pgaTypes.FDA_RAD, /*guidxx*/allprops.pgaGuid))//FDA_RAD_Values
);

const FDADRUForm = PGAComponent(
  () => import('./FDA_DRU'),
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `FDA_DRU_${merchandiseId}`, PGAReducer(pgaTypes.FDA_DRU, /*guidxx*/allprops.pgaGuid))}//FDA_DRU_Values
);

const EPAVNEForm = PGAComponent(
  () => import('./EPA_VNE'),
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `EPA_VNE_${merchandiseId}`, PGAReducer(pgaTypes.EPA_VNE, /*guidxx*/allprops.pgaGuid))}//EPA_VNE_Values
);
const EPAODSForm = PGAComponent(
  () => import('./tscaCert'),
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `TSCA_${merchandiseId}`, PGAReducer(pgaTypes.EPA_ODS, /*guidxx*/allprops.pgaGuid))}//EPA_ODS_Values
);

const APHAPQForm = PGAComponent(
  () => import('./APH_APQ'),
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `APH_APQ_${merchandiseId}`, PGAReducer(pgaTypes.APH_APQ, /*guidxx*/allprops.pgaGuid))}//APH_APQ_Values
);

const FDACOSForm = PGAComponent(
  () => import('./FDA_COS'),
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `FDA_COS_${merchandiseId}`, PGAReducer(pgaTypes.FDA_COS, /*guidxx*/allprops.pgaGuid))}//FDA_COS_Values
);

const FWSFWSForm = PGAComponent(
  () => import('./FWS_FWS'),
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `FWS_${merchandiseId}`, PGAReducer(pgaTypes.FWS, /*guidxx*/allprops.pgaGuid))}//FWS_Values
);

const EPAPS1Form = PGAComponent(
  () => import('./EPA_PS1'),
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `EPA_PS1_${merchandiseId}`, PGAReducer(pgaTypes.EPA_PS1, /*guidxx*/allprops.pgaGuid))}//EPA_PS1_Values
);
const EPAPS2Form = PGAComponent(
  () => import('./EPA_PS1'),//Intentional!
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `EPA_PS2_${merchandiseId}`, PGAReducer(pgaTypes.EPA_PS2, /*guidxx*/allprops.pgaGuid))}//EPA_PS2_Values
);
const EPAPS3Form = PGAComponent(
  () => import('./EPA_PS1'),//Intentional!
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `EPA_PS3_${merchandiseId}`, PGAReducer(pgaTypes.EPA_PS3, /*guidxx*/allprops.pgaGuid))}//EPA_PS3_Values
);

const ATFATFForm = PGAComponent(
  () => import('./ATF_ATF'),
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `ATF_ATF_${merchandiseId}`, PGAReducer(pgaTypes.ATF_ATF, /*guidxx*/allprops.pgaGuid))}//ATF_ATF_Values
);

const DEADEAForm = PGAComponent(
  () => import('./DEA_DEA'),
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `DEA_DEA_${merchandiseId}`, PGAReducer(pgaTypes.DEA_DEA, /*guidxx*/allprops.pgaGuid))}//DEA_DEA_Values
);

const AMSORForm = PGAComponent(
  () => import('./AMS_OR'),
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `AMS_OR_${merchandiseId}`, PGAReducer(pgaTypes.AMS_OR, /*guidxx*/allprops.pgaGuid))}//AMS_OR_Values
);
const AMSOR2Form = PGAComponent(
  () => import('./AMS_OR2'),
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `AMS_OR2_${merchandiseId}`, PGAReducer(pgaTypes.AMS_OR2, /*guidxx*/allprops.pgaGuid))}//AMS_OR2_Values
);

const AMSMOForm = PGAComponent(
  () => import('./AMS_MO'),
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `AMS_MO_${merchandiseId}`, PGAReducer(pgaTypes.AMS_MO, /*guidxx*/allprops.pgaGuid))}//AMS_MO_Values
);


const NMFSSIMForm = PGAComponent(
  () => import('./NMFS_SIM'),
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `NMFS_SIM_${merchandiseId}`, PGAReducer(pgaTypes.NMFS_SIM, /*guidxx*/allprops.pgaGuid))}//NMFS_SIM_Values
);

const APHAVSForm = PGAComponent(
  () => import('./APH_AVS'),
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `${allprops.formType}_${merchandiseId}`, PGAReducer(allprops.formType, /*guidxx*/allprops.pgaGuid))}//APH_AVS_Values
);

const FSIFSIForm = PGAComponent(
  () => import('./FSI_FSI'),
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `FSI_FSI_${merchandiseId}`, PGAReducer(pgaTypes.FSI_FSI, /*guidxx*/allprops.pgaGuid))}//FSI_FSI_Values
);

const NHTMVSForm = PGAComponent(
  () => import('./NHT_MVS'),
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `NHT_MVS_${merchandiseId}`, PGAReducer(pgaTypes.NHT_MVS, /*guidxx*/allprops.pgaGuid))}//NHT_MVS_Values
);
const NHTOFFForm = PGAComponent(
  () => import('./NHT_MVS'),//reuse mvs form
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `NHT_OFF_${merchandiseId}`, PGAReducer(pgaTypes.NHT_OFF, /*guidxx*/allprops.pgaGuid))}//NHT_OFF_Values
);
const FDATOBForm = PGAComponent(
  () => import('./FDA_TOB'),//reuse mvs form
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `FDA_TOB_${merchandiseId}`, PGAReducer(pgaTypes.FDA_TOB, /*guidxx*/allprops.pgaGuid))}//NHT_OFF_Values
);

const TTBALLTTB = PGAComponent(
  () => import('./TTB_ALL_TTB'),//reuse mvs form
  (merchandiseId,allprops) => {
    injectAsyncReducer(store, `${allprops.formType}_${merchandiseId}`, PGAReducer(pgaTypes[allprops.formType], /*guidxx*/allprops.pgaGuid))}//NHT_OFF_Values
);

const DISCLAIMSECTION = PGAComponent(
  () => import('./DISCLAIM_SECTION'),
  (merchandiseId,allprops) => {
    injectAsyncReducer(store, `DISCLAIM_SECTION_${merchandiseId}`, PGAReducer(pgaTypes[allprops.formType], /*guidxx*/allprops.pgaGuid))}//APH_AVS_Values
    
);

const OMCOMCForm = PGAComponent(
  () => import('./OMC_OMC'),
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `OMC_OMC_${merchandiseId}`, PGAReducer(pgaTypes.OMC_OMC, /*guidxx*/allprops.pgaGuid))}//OMC_OMC_Values
);

const NMF370Form = PGAComponent(
  () => import('./NMF_370'),
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `NMF_370_${merchandiseId}`, PGAReducer(pgaTypes.NMF_370, /*guidxx*/allprops.pgaGuid))}//NMF_370_Values
);

const NMFSHMSForm = PGAComponent(
  () => import('./NMFS_HMS'),
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `NMFS_HMS_${merchandiseId}`, PGAReducer(pgaTypes.NMFS_HMS, /*guidxx*/allprops.pgaGuid))}//NMFS_HMS_Values
);

const FDAVMEForm = PGAComponent(
  () => import('./FDA_VME'),
  (merchandiseId, allprops) => injectAsyncReducer(store, `FDA_VME_${merchandiseId}`, PGAReducer(pgaTypes.FDA_VME, /*guidxx*/allprops.pgaGuid))//FDA_VME_Values
);

const FDABIOForm = PGAComponent(
  () => import('./FDA_BIO'),
  (merchandiseId, allprops) => injectAsyncReducer(store, `FDA_BIO_${merchandiseId}`, PGAReducer(pgaTypes.FDA_BIO, /*guidxx*/allprops.pgaGuid))//FDA_BIO_Values
);

const NMFSAMRForm = PGAComponent(
  () => import('./NMFS_AMR'),
  (merchandiseId, allprops) => {
    injectAsyncReducer(store, `NMFS_AMR_${merchandiseId}`, PGAReducer(pgaTypes.NMFS_AMR, /*guidxx*/allprops.pgaGuid))}//NMFS_AMR_Values
);

class PGAItem extends React.Component {
  constructor(props) {
    super();
    this.state = {
      errorFields: [],
      loading: false,
    }
    this.setErrorFields = this.setErrorFields.bind(this)
    this.getPgaComponent = this.getPgaComponent.bind(this)
  }

  componentDidMount() {
    this.setState({
      PGAComponent: this.getPgaComponent(this.props.pgaType, this.props)
    })
  }

  setErrorFields(errorFields) {
    this.setState({
      errorFields
    })
  }

  getHeaders = () => {
    const {
      formType,
    } = this.props
    switch (formType) {
      case pgaTypes.LACEY:
        return [pgaHeaders.laceyActHeader, pgaHeaders.laceyActSubHeader]
      case pgaTypes.TSCA:
        return [pgaHeaders.tscaHeader, pgaHeaders.tscaSubHeader]
      case pgaTypes.DISCLAIM_PGA:
        return [pgaHeaders.fdaHeader, pgaHeaders.fdaSubHeader]
      case pgaTypes.NHTSA:
        return [pgaHeaders.nhtsaHeader, pgaHeaders.nhtsaSubHeader]
      // case pgaTypes.FDA_FOO:
      //   return [pgaHeaders.fdaFooHeader, pgaHeaders.fdaFooSubHeader]
      // case pgaTypes.FDA_DEV:
      //   return [pgaHeaders.fdaDevHeader, pgaHeaders.fdaDevSubHeader]
      // case pgaTypes.FDA_RAD:
      //   return [pgaHeaders.fdaRadHeader, pgaHeaders.fdaRadSubHeader]
      case pgaTypes.DEA_DEA:
        return [pgaHeaders.deaDeaHeader, pgaHeaders.deaDeaSubHeader]
      // case pgaTypes.AMS_OR:
      //   return [pgaHeaders.amsOrHeader, pgaHeaders.amsOrSubHeader]
      // case pgaTypes.FDA_DRU:
      //   return [pgaHeaders.fdaDruHeader, pgaHeaders.fdaDruSubHeader]
      // case pgaTypes.APH_AVS:
      //   return [pgaHeaders.aphAvsHeader, pgaHeaders.aphAvsSubHeader]
      // case pgaTypes.EPA_VNE:
      //   return [pgaHeaders.epaVneHeader, pgaHeaders.epaVneSubHeader]
      // case pgaTypes.APH_APQ:
      //   return [pgaHeaders.aphApqHeader, pgaHeaders.aphApqSubHeader]
      case pgaTypes.FWS:
        return [pgaHeaders.fwsFwsHeader, pgaHeaders.fwsFwsSubHeader]
      // case pgaTypes.EPA_PS1:
      //   return [pgaHeaders.epaPs1Header, pgaHeaders.epaPs1SubHeader]
      // case pgaTypes.EPA_PS2:
      //   return [pgaHeaders.epaPs2Header, pgaHeaders.epaPs2SubHeader]
      // case pgaTypes.EPA_PS3:
      //   return [pgaHeaders.epaPs3Header, pgaHeaders.epaPs3SubHeader]
      // case pgaTypes.AMS_OR:
      //   return [pgaHeaders.amsOrHeader, pgaHeaders.amsOrSubHeader]
      case pgaTypes.NMF_370:
        return [
          pgaHeaders.genericHeader("NMFS","370"),
          pgaHeaders.genericSubHeader("NMFS","370")
        ]
      default: {
        if(formType.split("_").length==2){
          return [
            pgaHeaders.genericHeader(formType.split("_")[0],formType.split("_")[1]),
            pgaHeaders.genericSubHeader(formType.split("_")[0],formType.split("_")[1])
          ]
        }
        return ['', '']}
    }
  }
  
  getPgaComponent(formType) {
    switch (formType) {
      case pgaTypes.LACEY:
        return <LaceyActForm {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.TSCA:
        return <TSCAForm {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.DISCLAIM_PGA:
        return <FDAForm {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} />
      // case pgaTypes.NHTSA:
      //   return <NHTSAForm {...this.props} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.NHT_OEI:
      case pgaTypes.NHT_TPE:
        return <NHTTPEForm {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.NHT_REI:
        return <NHTREIForm {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.FDA_VME:
        return <FDAVMEForm  {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.FDA_BIO:
        return <FDABIOForm  {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.FDA_FOO:
        return <FDAFOOForm {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.FDA_DEV:
        return <FDADEVForm {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.ATF_ATF:
        return <ATFATFForm {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.DEA_DEA:
        return <DEADEAForm {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.FDA_TOB:
        return <FDATOBForm {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />  
      case pgaTypes.FDA_RAD:
        return <FDARADForm {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.FDA_DRU:
        return <FDADRUForm {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.FDA_COS:
        return <FDACOSForm  {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.APH_AAC:
      case pgaTypes.APH_AVS:
        return <APHAVSForm {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.EPA_VNE:
        return <EPAVNEForm {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.EPA_ODS:
        return <EPAODSForm {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.APH_APQ:
        return <APHAPQForm {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.FWS:
        return <FWSFWSForm {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.EPA_PS1:
        return <EPAPS1Form {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.EPA_PS2:
        return <EPAPS2Form {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.EPA_PS3:
        return <EPAPS3Form {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.AMS_OR:
        return <AMSORForm  {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.AMS_OR2:
        return <AMSOR2Form  {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.AMS_MO:
        return <AMSMOForm  {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.FSI_FSI:
        return <FSIFSIForm  {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.NHT_MVS:
        return <NHTMVSForm {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />  
      case pgaTypes.NHT_OFF:
        return <NHTOFFForm {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />  
      case pgaTypes.NMFS_SIM:
        return <NMFSSIMForm {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />  
      case pgaTypes.TTB_BER:
      case pgaTypes.TTB_DSP:
      case pgaTypes.TTB_TOB:
      case pgaTypes.TTB_WIN:
        return <TTBALLTTB {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />  
      case pgaTypes.OMC_OMC:
        return <OMCOMCForm  {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.NMF_370:
        return <NMF370Form  {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />  
      case pgaTypes.NMFS_HMS:
        return <NMFSHMSForm  {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      case pgaTypes.NMFS_AMR:
        return <NMFSAMRForm {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
      default: return <DISCLAIMSECTION  {...this.props} launchFrom={this.props.launchFrom} setErrorFields={this.setErrorFields} formType={formType} />
    }
  }

  render() {
    const {
      formType,
      ...rest
    } = this.props
    
    const headers = this.getHeaders(formType)
    let pgaHeader = <PgaSectionLabels label={"PG01"} >
        <span>{headers[1]}</span>
      </PgaSectionLabels>
    return (
      <React.Fragment>
        <div className='lacey-act-header'>
          <div className='header-text'>
            <div className='header-text-small'>
              {pgaHeader}
            </div>
          </div>
        </div>
        <div className='lacey-act'>
          <div className='lacey-act-form' key={this.props.pgaGuid}>
            {/* {
              this.state.errorFields.length > 0
              && <Message
                style={{ display: 'block' }}
                error
                header={pgaErrors.pgaHeaderMessage}
                list={this.state.errorFields.map((error) => `${error[0]} : ${error[1]}`)}
              />
            } */}
            {
              this.getPgaComponent(formType)
            }
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, props) => ({

})

const mapDispatchToProps = {
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PGAItem)
